import { mergeStyles } from '../../../../../internal/utils/mergeStyles';
import mainStyles from './styles.module.css';
import { getDeviceStyles, getDeviceStylesIdentity } from './device';
import { memoizeWith } from 'ramda';
function getModalWindowStyles(deviceType, size) {
  const deviceStyles = getDeviceStyles(deviceType, size);
  return mergeStyles(mainStyles, deviceStyles);
}
export const getStyles = memoizeWith(getDeviceStylesIdentity, getModalWindowStyles);